export default "__VITE_ASSET__BujR_TsT__"